import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import { supabase } from '../supabaseClient';
import mirrorimage from '../mirrorimage.webp';

function Action({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'action',
                    animated_helper: 'no', // always set to 'no'
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                alert('Failed to save progress: ' + progressError.message);
                return;
            }
            alert('Session progress has been saved successfully!');
        } catch (err) {
            alert('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .action-btn-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                    }
                    .action-btn {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 100px !important;
                        padding: 10px 0 !important;
                        font-size: 16px !important;
                    }
                }
                `}
            </style>
            <div style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
            }}>
                {/* Title */}
                <h3 style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'black',
                    marginBottom: '32px',
                }}>
                    Action
                </h3>

                {/* Top Card with Image, Title, and Subtitle */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '600px',
                        borderRadius: '10px',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        border: '2px solid black',
                        marginBottom: '24px',
                        overflow: 'hidden',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        textAlign: 'center',
                    }}
                >
                    <img
                        src={mirrorimage}
                        alt="Mirror"
                        style={{
                            width: '100%',
                            borderRadius: '10px 10px 0 0',
                            objectFit: 'cover',
                            maxHeight: '220px',
                        }}
                    />
                    <div
                        style={{
                            padding: '24px',
                            background: 'rgba(255,255,255,0.85)',
                            borderBottomLeftRadius: '10px',
                            borderBottomRightRadius: '10px',
                        }}
                    >
                        <h2
                            style={{
                                fontFamily: 'Times New Roman, Times, serif',
                                fontSize: '28px',
                                fontWeight: 'bold',
                                color: '#4B5563',
                                margin: '0 0 16px 0',
                            }}
                        >
                            Action
                        </h2>
                        <p
                            style={{
                                fontFamily: 'Times New Roman, Times, serif',
                                fontSize: '16px',
                                color: '#4B5563',
                                margin: 0,
                            }}
                        >
                            Taking action, even small steps, moves energy and creates change.
                        </p>
                    </div>
                </div>


                {/* Session Helper Cards Row */}
                <div
                    className="action-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            • Our intution informs our next best action<br />
                            • Inner urge should prompt us to action<br />
                            • Curiousity is another prompt to act.<br />
                            • Sometimes an inablity to act can come from being stuck in a freeze response to trauma.<br />
                            • Sometimes taking action is just one foot in front of the other.<br />
                            • Rest is valid too.
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            1. How are the feminine and masculine aspects of your energy body working together?<br />
                            2. Does your masculine aspect trust the intuition of your feminine aspect?<br />
                            3. Does your feminine aspect feel let down by being questioned and doubted?<br />
                            4. What examples of how this energy works together were you shown when you were growing up?<br />
                            5. Has there been a time when you knew you should take action but could not?<br />
                            6. Have you used the ToDo list on this app to keep track of things you want to take action on?
                        </div>
                    </div>
                </div>

                {/* Cards */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                }}>
                    {/* Card 1 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            As a person who has spent a majority of the first 40 years of her life in the Freeze response, I can tell you that I learned about the importance of taking action by not taking any for a long time. One day I came a cross a meme or a blog in my research about how to love myself.  It said that you can take the steps to show yourself love starting today and in 10 years you will have made progress, or you can wait and the time will pass anyway and you will still be where you are today. For some reason that was what I needed to hear.  It scared me.  I did NOT want to be where I was.. and the thought of being there another 10 years was unbearable.   So, from that point forward I was not able to not show up for myself in some small way every day.  It has been 10 years since then and I am so glad I did. 
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Taking action doesn't even have to be about doing something physically with our body, but we all know that is highly beneficial to humans.  Taking action can be about making effort to change thoughts, to process feelings, to look people in the eye when we speak to them.  Taking action is the step that comes after our inspiration.  We get inspired by our intuition. Our feminine receptivity opens us to hear what our soul calls to, or what our heart wants to allow in.  Our masculine essence takes the action to follow through on it.  The masculine part of us is the doing part of us.  The strategizing part of us can sometimes look for the easiest way to complete a task we have been inspired to, or the driven part of us can just want to work hard to acheive.  We all have these feminine and masculine aspects of our energy and they can learn to work very well together to get things done, overcome obstacles, and acheive our dreams.  Slow and steady consistent steps get us there!  <br /> Another place where action comes into play is when we need to make a decision.  Sometimes we have to trust ourselves or depend on ourselves to choose and that is what the experience is about.  We cannot bypass the need to make a decision at some points in our journey.  Knowing our strengths, weaknesses, and values will assist us to do that immensely. These topics have pages on this app where you can explore them for yourself further. Being prepared to take action whether it be toward an inspired impetus or a decision we need to make is worthwhile and possible. <br /> If we have set our intention toward a certain direction or outcome, any practiced habitual way of being that would contradict our intention will come to the surface to be balanced out.  Good intentions are not always enough to get something done when we have practiced habits that will get in the way. Practiced habits can even just include ways of thinking of feeling, not just ways of behaving.  
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <img
                            src="/images/self%20healing%20formula%20Meme.webp"
                            alt="Formula for Self Reflecting. Shaming, Blaming, Judging, Admiring are all something to Acknowledge in self. Next Identify reason for believing this, or reacting this way.  This means you validate and understand yourself. Next feel your experience of the situation.  Accept that this feeling exists for each feeling. Then Love the part of you who feels it. Offer unconditional Presence with what is."
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '220px',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                marginBottom: '12px'
                            }}
                        />
                    </div>
                    {/* New Card above navigation buttons */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: '16px',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                           The first step in changing this pattern is to acknowledge that the pattern or issue exists. You may have noticed it naturally, d​u​ring some self-inquiry, noticed it in someone else, or someone else pointed it out to you. <br /> Acknowledgement of the issue just means that you are aware of it existing. <br /> Validate -  This step has the purpose of soothing our defense mechanisms and protective skills. Our ego can convince us of our justification and even our victimized stance in any given situation where it was deemed helpful to our survival. <br /> These coping and defense strategies are part of what we are here to learn from and through. It is not wrong that we have this. It is important to validate ourselves on having them. Whatever our reasons may be for having or repeating the experience, or continuing the habit we now want to rid ourselves of, it is a valid reason for us. <br /> We are the only ones with our perspective and experiences. No one else has the same exact experience because they can only experience from their own point of view. So, having your experience and your perspective of your experience is your own expertise. <br />  Therefore it makes sense that you take the time to understand this about yourself. Why you might have chosen that response, denial, projection, or behavior. This step allows you to take the time to understand yourself more in a kind gentle way. <br /> Accept -  This step means that we are in acceptance of what is. Even if we do not agree with or like the experience, feeling, or behavior, we accept that it exists. <br />  When we accept, we are going to get some relief if we have been in resistance. Acceptance replaces resistance to what is. Resistance to what is causes us pain. <br />   Acceptance opens your central channel where energy moves through you. This step gets you ready to become the version of yourself that can process this. <br /> Presence - This step means that we are in the moment allowing whatever feelings are associated with the experience to be with us unconditionally. We do not blame, or wish it was different at this step. We do not think about the cause, how valid it is, or any of the past or future. <br /> We just allow this feeling to be with us as long as it needs. Eventually the feeling, which is an energy, will move through us as we become the version of ourselves that can process this feeling. If there are many feelings, we want to allow each one. <br />  It is important not to do this step while hoping that the feeling moves quickly or for the purpose of getting rid of the feeling. This feeling needs our presence, which means we are just going to be with it. <br /> Replace -  Now that you have cleared the pattern your view has expanded. From this place you can decide what you want to fill that space with. <br /> Presence is a wonderful choice. The more presence we can have in our lives, the more in touch with our true nature we can be. Whatever we invest in from that space is bound to be fulfilling.

                        </p>
                    </div>
                {/* End of Replace cardStyle divs */}

                {/* Navigation Buttons */}
                <div
                    className="action-btn-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginTop: '32px',
                    }}>
                    <button
                        className="action-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goBack}
                    >Back</button>
                    <button
                        className="action-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goHome}
                    >Home</button>
                    <button
                        className="action-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={handleSaveProgress}
                    >Save</button>
                </div>
            </div>
            </div>
        </>
    );
}

export default Action;
